import { render, staticRenderFns } from "./friendlyLink.vue?vue&type=template&id=4b1c57ba&scoped=true"
import script from "./friendlyLink.vue?vue&type=script&lang=js"
export * from "./friendlyLink.vue?vue&type=script&lang=js"
import style0 from "./friendlyLink.vue?vue&type=style&index=0&id=4b1c57ba&prod&lang=scss&scoped=true"
import style1 from "./friendlyLink.vue?vue&type=style&index=1&id=4b1c57ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1c57ba",
  null
  
)

export default component.exports